import React from 'react';
import cx from 'classnames';
import { Icons } from '../Icons';
// pill component
export const Pill = ({ title = '', icon, type = 'infringement' }) => {
    return (React.createElement("div", { className: cx('pill', `pill--${type}`) },
        React.createElement(Icons, { iconName: icon, size: 14, className: "pill_icon" }),
        title !== '' && React.createElement("span", { className: "pill_text" }, title)));
};
//# sourceMappingURL=Pill.js.map